import {Component, forwardRef, Input} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {Selectable} from '../../../../models/selectable.model';

const CB_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => AComboBoxComponent),
    multi: true
};

@Component({
    selector: 'a-combo-box',
    templateUrl: './a-combo-box.component.html',
    styleUrls: ['./a-combo-box.component.scss'],
    providers: [CB_VALUE_ACCESSOR],
    standalone: false
})
export class AComboBoxComponent implements ControlValueAccessor {

    @Input() items: Selectable[];
    @Input() disabled: boolean = false;
    @Input() required: boolean = false;
    @Input() multiple: boolean = false;
    @Input() clearable: boolean = false;
    @Input() appendTo: string;
    @Input() groupByFn: (item: Selectable) => any;
    @Input() groupValueFn: (groupId: any, children: Selectable[]) => { name: string, total: number };
    @Input() addTag: boolean = false;
    @Input() addTagText: string = 'Add new';
    @Input() placeholder: string = '';

    selection: Selectable;

    onChange = (_: any) => {
    };

    onTouched = () => {
    };

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    writeValue(obj: any): void {
        this.selection = obj;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    public compareFn = (a: Selectable, b: Selectable) => {
        return a === b || (a && b && a._id === b._id);
    }
}
